import * as handler from './handler';
import { PATH_PORTFOLIOS, PATH_PORTFOLIO_POSITIONS } from './path';

const getActiveStrategy = (userId, portfolioId) =>
  handler.get(`${PATH_PORTFOLIOS + userId}/${portfolioId}/strategies`).then((res) => {
    return res;
  });

const updatePortfolioDetails = (userId, portfolioId, payload) =>
  handler.put(`${PATH_PORTFOLIOS + userId}/${portfolioId}`, payload).then((res) => {
    return res;
  });

const removePortfolio = (userId, portfolioId) =>
  handler.delet(`${PATH_PORTFOLIOS + userId}/${portfolioId}`).then((res) => {
    return res;
  });

const getPositions = (userId, portfolioId) =>
  handler.get(`${PATH_PORTFOLIOS + userId}/${portfolioId}/positions`).then((res) => {
    return res;
  });

const getConnectedPortfolioDetails = (portfolioId) =>
  handler.get(PATH_PORTFOLIOS + portfolioId).then((res) => {
    return res;
  });

const getPortfolioBrokers = (params) =>
  handler.get(PATH_PORTFOLIO_POSITIONS, params, { withCredentials: false }).then((res) => {
    return res;
  });

export default { getActiveStrategy, updatePortfolioDetails, removePortfolio, getPositions, getConnectedPortfolioDetails, getPortfolioBrokers };
